import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../utils/propUtils';
import VeltReactionsPanelItemEmojiWireframe from './VeltReactionsPanelItemEmojiWireframe/VeltReactionsPanelItemEmojiWireframe';
var VeltReactionsPanelItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-item-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelItemWireframe.Emoji = VeltReactionsPanelItemEmojiWireframe;
export default VeltReactionsPanelItemWireframe;
